import { TEMPLATE_APPENDIX_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";
import { IPagination } from "../../shared/interfaces/shared/IPagination";
import { IBaseModel } from "../../shared/interfaces/shared/IBase";
import { ITemplateAppendix } from "../../shared/interfaces/templateAppendix/ITemplateAppendix";

export const TemplateAppendixService = {
  get: (pagination: IPagination): Promise<IBaseModel<ITemplateAppendix[]>> =>
    requests.get(TEMPLATE_APPENDIX_URL, pagination),
  getSingle: (id: number): Promise<ITemplateAppendix> =>
    requests.get(`${TEMPLATE_APPENDIX_URL}/${id}`),
  create: (params: ITemplateAppendix) => requests.post(TEMPLATE_APPENDIX_URL, params),
  update: (params: ITemplateAppendix, id: number) =>
    requests.put(`${TEMPLATE_APPENDIX_URL}/${id}`, params),
  delete: (id: number) => requests.delete(`${TEMPLATE_APPENDIX_URL}/${id}`),
};
